module.exports = __webpack_public_path__ + "img/cattunnel39.72a24f7c.jpg";